import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Notification } from 'types/api/notification.type';

import { useAppSelector } from 'redux/hooks';

import { notificationDataService } from 'services/notification.service';

import { LayoutContext } from 'contexts';

import { useFetch } from 'hooks';

import { formatSeasonLabel } from 'helpers/formatSeason';

import { Item } from './components/Item';

const useList = () => {
  const { season, marketLine } = useAppSelector((state) => state.settings);

  const { breadcrumbSet, breadcrumbSecondarySet } = useContext(LayoutContext);

  const [notifications, notificationsSet] = useState<Notification[]>([]);
  const { t } = useTranslation();
  const { content, isLoading } = useFetch(
    season && marketLine
      ? () => notificationDataService.getAll(season, marketLine)
      : undefined,
    [season, marketLine]
  );

  const notificationsItems = notifications?.map((item) => (
    <Item key={item.title.en} {...item} />
  ));

  useEffect(() => {
    if (season) {
      const breadcrumb = [
        {
          label: t('notification.label_other'),
        },
      ];

      const breadcrumbSecondary = [
        {
          label: formatSeasonLabel(season),
        },
        {
          label: t('notification.label_other'),
        },
      ];

      breadcrumbSet(breadcrumb);
      breadcrumbSecondarySet(breadcrumbSecondary);
    }
  }, [season]);

  useEffect(() => {
    if (content) {
      notificationsSet(content.content);
    }
  }, [content]);

  return { notificationsItems, isLoading };
};

export { useList };
